/**
 * Shared styling tokens for integrations email-triggers UIs (light + dark).
 */

/** SelectDropdown trigger — borders visible on slate/navy backgrounds */
export const INTEGRATIONS_SELECT_BUTTON_CLASS =
  "border border-slate-300 dark:border-slate-600 shadow-sm max-w-full";

/**
 * Labels above filters (Company, Target inbox, etc.).
 * Uses explicit `dark:` text so labels stay readable on dark shells.
 */
export const INTEGRATIONS_FIELD_LABEL_CLASS =
  "text-xs font-medium text-slate-600 dark:text-slate-200";

/**
 * Table `<th>` cells — must set text color explicitly or headers inherit low-contrast defaults in dark mode.
 */
export const INTEGRATIONS_TABLE_HEAD_CELL_CLASS =
  "text-left text-sm font-medium text-slate-600 dark:text-slate-200";

export const INTEGRATIONS_TABLE_HEAD_CELL_CENTER_CLASS =
  "text-center text-sm font-medium text-slate-600 dark:text-slate-200";

export const INTEGRATIONS_TABLE_HEAD_CELL_RIGHT_CLASS =
  "text-right text-sm font-medium text-slate-600 dark:text-slate-200";
